/**
 * WebSocket types and interfaces
 */

// Match the server-side event types
export enum SocketEventType {
  // Client to server events
  UserChatMessage = 'user_chat_message',
  ConversationStatus = 'conversation_status',
  GenerateSummary = 'generate_summary',

  // Server to client events
  AssistantChatMessage = 'assistant_chat_message',
  ChatError = 'chat_error',
  MessageStatus = 'message_status',
  ThinkingUpdate = 'thinking_update',
  SummaryUpdate = 'summary_update',

  // System events
  Connect = 'connection',
  Disconnect = 'disconnect',
  Reconnect = 'reconnect',
  Authentication = 'authentication',
}

export interface SocketMessage<T> {
  type: SocketEventType;
  payload: T;
  timestamp: string;
}
